/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/dtw-1.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/dtw-1.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/dtw-1.mdx';

const metadata = {
  slug: "dtw-1",
  title: "DTW #1: The First Forum",
  author: "Christian Battaglia",
  description: "Notes from the very first Down the Whole forum — five friends on a call covering Pythagorean hammers, binaural beats, alpha waves, titanium alloys, p-values, and everything in between. Plus: how to make it better next time.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-01-14T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["DTW","podcast","deep thinking","music","neuroscience","community","discussions","philosophy","science"],
};

export const Route = createFileRoute('/blog/posts/dtw-1')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/dtw-1',
    image: '/og/blog/dtw-1.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
